import { ReactElement, ReactNode, useState } from 'react'
import { Modal } from 'components'

interface IDeleteSiloModalProps {
  onConfirm(): void
  children?: ReactNode
}

const useDeleteSiloModal = ({
  onConfirm,
  children,
}: IDeleteSiloModalProps): [ReactElement, VoidFunction] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleConfirm = () => {
    onConfirm()
    setIsOpen(false)
  }

  return [
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Attention!"
      onConfirm={handleConfirm}
      onConfirmButtonText="Ok"
    >
      {children}
    </Modal>,
    () => setIsOpen(!isOpen),
  ]
}

export default useDeleteSiloModal
